/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  downloadAllFiles: {
    id: 'DOWNLOAD_AUDIO_BUTTON.download_all_files',
    defaultMessage: 'DOWNLOAD AUDIO FILES',
  },
  audioFile: {
    id: 'DOWNLOAD_AUDIO_BUTTON.audio_file',
    defaultMessage: 'Audio File',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/DownloadAudioButton/messages.js